import React, { useContext, useEffect, useState } from 'react'
import {  SwitchBox, SwitchDiv, SwitchesDiv, SwitchInput, SwitchSlider } from './style'
import { allPermissions, headerProfilesTable } from '../utils'
import axios from 'axios'
import UserContext from '../../../../contexts/UserContext'
import { useProfileContext } from '../../../../contexts/AccessesContext'
import trash from '../../../../assets/assesses/trash.svg'
import ModalContext from '../../../../contexts/ModalContext'
import LoadMoreButton from '../../../../components/Accesses/LoadMoreButton'
import { GlobalTable, HeaderLine, Td, Th, Tr } from '../../../../components/table-style'
import { useOutletContext } from 'react-router-dom'
import { PeopleOutletType } from '..'

interface Profile {
  id: number
  name: string
  admin: boolean
  permissions: string[]
  createdAt: string
  updatedAt: string
}

const TableProfile = () => {
  const { profiles, setProfiles, setDeletedProfile, fetchProfilesWithoutAdmin } = useProfileContext()
  const [checkedState, setCheckedState] = useState<{ [key: string]: boolean }>({})
  const { setModalActive, setModalSection } = useContext(ModalContext)
  const { token } = useContext(UserContext)
  const [ refreshTrigger, setRefreshTrigger ] = useState(0)
  const { setTabIndex } = useOutletContext<PeopleOutletType>()
  
  useEffect(() => {
    setTabIndex(1)
  }, [])
  
  useEffect(() => {
    const initialCheckedState: { [key: string]: boolean } = {}
    profiles.filter((profile: Profile) => profile.id !== 3).forEach((profile, profileIndex) => {
      allPermissions.forEach((permission, permissionIndex) => {
        initialCheckedState[`${profileIndex}-${permissionIndex}`] = profile.permissions.includes(permission)
      })
    })
    setCheckedState(initialCheckedState)
  }, [])

  const handleDelete = async (id: number) => {
    setDeletedProfile(id)
    setModalActive(true)
    setModalSection('deleteProfile')
  }

  useEffect(() => {
    fetchProfilesWithoutAdmin()
  }, [])



  const updateProfilePermissions = async (profileId: number, updatedPermissions: string[]) => {
    try {
      await axios.patch(
        `${process.env.REACT_APP_BASE_URL}/profile/${profileId}`,
        { permissions: updatedPermissions },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
    } catch (error) {
      console.error('Erro ao atualizar permissões', error)
    }
  }

  const handleCheckboxChange = (profileIndex: number, permissionIndex: number) => {
    const key = `${profileIndex}-${permissionIndex}`
    const permissionName = allPermissions[permissionIndex]

    setCheckedState((prevCheckedState) => {
      const newCheckedState = {
        ...prevCheckedState,
        [key]: !prevCheckedState[key],
      }

      setProfiles((prevProfiles) => {
        const updatedProfiles = [...prevProfiles]
        const profile = updatedProfiles[profileIndex]

        if (newCheckedState[key]) {
          if (!profile.permissions.includes(permissionName)) {
            profile.permissions.push(permissionName)
          }
        } else {
          profile.permissions = profile.permissions.filter((perm) => perm !== permissionName)
        }

        updateProfilePermissions(profile.id, profile.permissions)

        return updatedProfiles
      })

      return newCheckedState
    })
  }

  const itemsOfTable = (permissionType: string, profileIndex: number, permissionIndex: number, id: number) => {
    const element = permissionType !== 'delete' ? (
      <SwitchesDiv>
        <SwitchDiv>
          <SwitchBox>
            <SwitchInput
              type="checkbox"
              checked={checkedState[`${profileIndex}-${permissionIndex}`]}
              onChange={() => handleCheckboxChange(profileIndex, permissionIndex)}
            />
            <SwitchSlider className="slider"></SwitchSlider>
          </SwitchBox>
        </SwitchDiv>
      </SwitchesDiv>
    ) : (
      <img src={trash} alt="trash icon" onClick={() => handleDelete(id)} className="trash" />
    )

    return element
  }

  return (
    <>
      <GlobalTable>
        <thead>
          <HeaderLine>
            {headerProfilesTable.map((item, indexHeader) => (
              <Th key={indexHeader}>{item}</Th>
            ))}
          </HeaderLine>
        </thead>
        <tbody>
          {profiles.map((profile, indexProfiles) => (
            <Tr key={indexProfiles}>
              {allPermissions.map((permission, indexPermissions) => (
                <Td key={indexPermissions}>
                  {permission === 'name' ? <>{profile.name}</> : itemsOfTable(permission, indexProfiles, indexPermissions, profile.id)}
                </Td>
              ))}
            </Tr>
          ))}
        </tbody>
      </GlobalTable>
      <LoadMoreButton />
    </>
  )
}

export default TableProfile
